/**
 * useCamera — utility functions
 */

import type { ImageCaptureConstructor, WindowWithImageCapture } from './types';

export function getImageCaptureConstructor(): ImageCaptureConstructor | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const runtimeWindow = window as WindowWithImageCapture;
  return typeof runtimeWindow.ImageCapture === 'function'
    ? runtimeWindow.ImageCapture
    : null;
}

export function getErrorName(error: unknown): string {
  return error instanceof Error ? error.name : '';
}

export function getErrorMessage(error: unknown, fallback = ''): string {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return fallback;
}
